// extracted by mini-css-extract-plugin
export default {"create-card-import__file":"CreateCardImport_create-card-import__file__cQCls"};